import { type WorkspaceAgentMessage } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentMessage';

const isConfirmedUserMessage = (message: WorkspaceAgentMessage): boolean =>
  message.role === 'user' && !message.isPending && !message.id.startsWith('temp:');

/** Latest server-confirmed user message — ignores optimistic rows. */
export const getLatestConfirmedUserMessageId = (messages: readonly WorkspaceAgentMessage[]): string | null => {
  let latestUserMessageId: string | null = null;
  let latestSequence = Number.NEGATIVE_INFINITY;

  for (const message of messages) {
    if (!isConfirmedUserMessage(message) || message.sequence <= latestSequence) {
      continue;
    }

    latestSequence = message.sequence;
    latestUserMessageId = message.id;
  }

  return latestUserMessageId;
};
